<form [formGroup]="ExamSubForm">
    <div class="col-lg-12 col-md-12 col-sm-12">
        <div class="row m-3 ml-2 mr-2">
            <div class="bc d-flex align-items-center p-3">
                <div class="col-sm-6 text-center ">
                    <h3 class="main-content-label mb-0"><b>
                            {{'header.exam-subject.table.Course'| translate}} - {{CourseName}}
                        </b></h3>
                </div>
                <div class="col-sm-6 text-center ">
                    <h3 class="main-content-label mb-0"><b>
                            {{'header.exam-subject.table.ExamName'| translate}} - {{ExamName}}
                        </b></h3>
                </div>
            </div>

        </div>
        <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" [selectedIndex]="selectedIndex">
            <mat-tab label=" {{Title}} Details" [selectedIndex]="selectedIndex">
                <div class="card-body pl-1 mt-3">
                    <div class="row clearfix">
                        <!-- margindotted -->
                        <div class="col-sm-12 ">
                            <h6 class="main-content-label f10">
                                <!-- {{selectedoption}} -->
                                {{Title}}
                            </h6>
                            <div class="row" *ngIf="selectedoption !== 'S'">
                                <div *ngIf="Type !== 'S'">
                                    <!-- *ngIf="selectedoption == 'Subject'" -->
                                    <div class="row">
                                        <div class="col-sm-4">
                                            <div
                                                *ngIf="selectedoption == 'I' || selectedoption == 'H' || Type == 'I' || Type == 'H'|| selectedoption == 'P' || Type == 'P'">
                                                <mat-form-field appearance="outline" class="example-full-width">
                                                    <mat-label>
                                                        {{'header.exam-subject.table.ExamSubject'| translate}}
                                                    </mat-label>
                                                    <mat-select [disabled]="disableDelete" required #select601
                                                        class="colorblack" formControlName="ESUBID">
                                                        <mat-select-filter *ngIf="select601.focused"
                                                            [placeholder]="'Filter'" [displayMember]="'EsName'"
                                                            [array]="EsCodeArr"
                                                            (filteredReturn)="filteredListCode =$event">
                                                        </mat-select-filter>
                                                        <mat-option *ngFor="let e of filteredListCode" [value]="e.EsId"
                                                            (click)="subjectSelect(e)">
                                                            {{ e.EsCode ? e.EsCode + ' - ' + e.EsName : e.EsName }}
                                                        </mat-option>
                                                    </mat-select>
                                                    <mat-error class="margin_tp"
                                                        *ngIf="ExamSubForm.controls['ESUBID'].touched && ExamSubForm.controls['ESUBID'].errors?.required">
                                                        {{'header.exam-subject.table.Mandatory'| translate}}
                                                    </mat-error>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                        <div class="col-sm-4" *ngIf="Part">
                                            <mat-form-field appearance="outline" class="example-full-width"
                                                *ngIf="selectedoption == 'I' || selectedoption == 'H' || Type == 'I' || Type == 'H'">
                                                <mat-label>
                                                    {{'header.exam-subject.table.ExamPart'| translate}}
                                                </mat-label>

                                                <mat-select [disabled]="disableDelete" #select64 class="colorblack"
                                                    formControlName="ESubPart">
                                                    <mat-select-filter *ngIf="select64.focused" [placeholder]="'Filter'"
                                                        [displayMember]="'EsName'" [array]="EsCodeArr1"
                                                        (filteredReturn)="filteredListCode1 =$event">
                                                    </mat-select-filter>
                                                    <mat-option *ngFor="let e of filteredListCode1" [value]="e.EsId "
                                                        (click)="singleRecordInPart(e.EsId)">
                                                        {{e.EsCode}} - {{e.EsName}}
                                                    </mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </div>

                                        <div class="col-sm-3" *ngIf="PaperType">
                                            <div
                                                *ngIf="selectedoption == 'I' || selectedoption == 'H' || Type == 'I' || Type == 'H'">
                                                <mat-form-field appearance="outline" class="example-full-width">
                                                    <mat-label>
                                                        Paper type
                                                    </mat-label>
                                                    <mat-select [disabled]="disableDelete" #select601 class="colorblack"
                                                        formControlName="PType">
                                                        <mat-select-filter *ngIf="select601.focused"
                                                            [placeholder]="'Filter'" [displayMember]="'PType'"
                                                            [array]="paperTypeList"
                                                            (filteredReturn)="paperTypeListData =$event">
                                                        </mat-select-filter>
                                                        <mat-option *ngFor="let e of paperTypeListData"
                                                            [value]="e.CdCode" (click)="paperTypeSelect(e)">
                                                            {{ e.CdDesc }}
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </div>

                                        </div>
                                        <div class="col-sm-3 mt-1" *ngIf="PaperType">
                                            <mat-checkbox [disabled]="disableDelete" class="example-margin"
                                                formControlName="NotPrintAdmitCrd"
                                                *ngIf="selectedoption == 'I' || selectedoption == 'H' || Type == 'I' || Type == 'H'">
                                                Do Not Show On Admit Card
                                            </mat-checkbox>
                                        </div>

                                        <div class="col-sm-4" *ngIf="InPart">
                                            <mat-form-field appearance="outline" class="example-full-width"
                                                *ngIf="selectedoption == 'H' || Type == 'H'">
                                                <mat-label>
                                                    {{'header.exam-subject.table.ExamInPart'| translate}}
                                                </mat-label>
                                                <mat-select [disabled]="disableDelete" #select61 class="colorblack"
                                                    formControlName="ESubInPart">
                                                    <mat-select-filter *ngIf="select61.focused" [placeholder]="'Filter'"
                                                        [displayMember]="'EsName'" [array]="EsCodeArr2"
                                                        (filteredReturn)="filteredListCode2 =$event">
                                                    </mat-select-filter>
                                                    <mat-option (click)=this.setgroupParentID(e.EsId)
                                                        *ngFor="let e of filteredListCode2" [value]="e.EsId">
                                                        {{e.EsCode}} - {{e.EsName}}
                                                    </mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-4">
                                            <mat-form-field appearance="outline" class="example-full-width">
                                                <mat-label>
                                                    {{Title}} {{'header.exam-subject.table.ExamSubjectCode'| translate}}
                                                </mat-label>
                                                <input appUppercase [readonly]="disable || disableDelete" required class="color"
                                                    matInput placeholder="Code" formControlName="EsCode"
                                                    (change)="checkduplicate()">
                                                <!-- (change)="checkduplicate()" -->
                                                <mat-error class="margin_tp"
                                                    *ngIf="ExamSubForm.controls['EsCode'].touched && ExamSubForm.controls['EsCode'].errors?.pattern">
                                                    {{'header.exam-subject.table.Invalid'| translate}}
                                                </mat-error>
                                                <mat-error class="margin_tp"
                                                    *ngIf="ExamSubForm.controls['EsCode'].touched && ExamSubForm.controls['EsCode'].errors?.required">
                                                    {{'header.exam-subject.table.Mandatory'| translate}}
                                                </mat-error>
                                            </mat-form-field>
                                        </div>

                                        <div class="col-sm-5">
                                            <mat-form-field appearance="outline" class="example-full-width">
                                                <mat-label>
                                                    Name
                                                </mat-label>
                                                <input appCamelcase [readonly]="disableDelete" required class="color"
                                                    matInput placeholder="Name" formControlName="EsName">

                                                <mat-error class="margin_tp"
                                                    *ngIf="ExamSubForm.controls['EsName'].touched && ExamSubForm.controls['EsName'].errors?.pattern">
                                                    {{'header.exam-subject.table.Invalid'| translate}}
                                                </mat-error>
                                                <mat-error class="margin_tp"
                                                    *ngIf="ExamSubForm.controls['EsName'].touched && ExamSubForm.controls['EsName'].errors?.required">
                                                    {{'header.exam-subject.table.Mandatory'| translate}}
                                                </mat-error>
                                            </mat-form-field>
                                        </div>

                                        <div class="col-sm-3 pr-0">
                                            <mat-form-field appearance="outline" class="example-full-width">
                                                <mat-label>
                                                    Print
                                                    Y/N/H
                                                </mat-label>
                                                <mat-select [disabled]="disableDelete" required #select59
                                                    class="colorblack" formControlName="EsPrint">
                                                    <mat-select-filter *ngIf="select59.focused" [placeholder]="'Filter'"
                                                        [displayMember]="'name'" [array]="printSelectDropDown"
                                                        (filteredReturn)="filterlistprintSelectDropDown =$event">
                                                    </mat-select-filter>
                                                    <mat-option *ngFor="let item of filterlistprintSelectDropDown"
                                                        [value]="item.id">
                                                        {{item.name}}
                                                    </mat-option>
                                                </mat-select>

                                                <mat-error class="margin_tp"
                                                    *ngIf="ExamSubForm.controls['EsPrint'].touched && ExamSubForm.controls['EsPrint'].errors?.required">
                                                    {{'header.exam-subject.table.Mandatory'| translate}}
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                        <!-- attendance checkbox -->
                                        <div class="col-sm-3 pr-0">
                                              <mat-checkbox class="example-margin"
                                                formControlName="AttendanceRequired"
                                                *ngIf="selectedoption == 'P'">
                                                Attendance Required?
                                            </mat-checkbox>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row" *ngIf="selectedoption == 'S' || Type == 'S'">
                                <!-- *ngIf="selectedoption == 'Subject'" -->
                                <div class="row">
                                    <div class="col-sm-3">
                                        <mat-form-field appearance="outline" class="example-full-width">
                                            <mat-label>
                                                Group
                                            </mat-label>
                                            <mat-select [disabled]="disableDelete" #select60 class="colorblack"
                                                formControlName="ESubGroup">
                                                <mat-select-filter *ngIf="select60.focused" [placeholder]="'Filter'"
                                                    [displayMember]="'item.EsName'" [array]="filteredListGroup"
                                                    (filteredReturn)="filteredListGroup =$event">
                                                </mat-select-filter>
                                                <mat-option (click)="setgroupParentID(item.EsId)"
                                                    *ngFor="let item of EsGroup" [value]="item.EsId ">
                                                    <!-- {{item.EsCode}} - {{item.EsName}} -->
                                                    {{item.EsName}}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-3">
                                        <mat-form-field appearance="outline" class="example-full-width">
                                            <mat-label>
                                                Subject Code
                                            </mat-label>
                                            <!-- (change)="checkduplicateSubCode()" -->
                                            <input appUppercase maxlength="10" [readonly]="disable || disableDelete" required
                                                class="color" matInput placeholder="Code" formControlName="EsCode"
                                                (change)="checkduplicateSubCode()">
                                            <mat-error class="margin_tp"
                                                *ngIf="ExamSubForm.controls['EsCode'].touched && ExamSubForm.controls['EsCode'].errors?.pattern">
                                                Invalid
                                            </mat-error>
                                            <mat-error class="margin_tp"
                                                *ngIf="ExamSubForm.controls['EsCode'].touched && ExamSubForm.controls['EsCode'].errors?.required">
                                                Mandatory
                                            </mat-error>
                                        </mat-form-field>

                                    </div>
                                    <div class="col-sm-3">
                                        <mat-form-field appearance="outline" class="example-full-width">
                                            <mat-label>
                                                Short Name
                                            </mat-label>
                                            <input [readonly]="disableDelete" required class="color" matInput
                                                placeholder="ShName" maxlength="20" formControlName="EsShName">
                                            <mat-error class="margin_tp"
                                                *ngIf="ExamSubForm.controls['EsShName'].touched && ExamSubForm.controls['EsShName'].errors?.required">
                                                Mandatory
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-sm-3">
                                        <mat-form-field appearance="outline" class="example-full-width">
                                            <mat-label>
                                                Name
                                            </mat-label>
                                            <input appCamelcase [readonly]="disableDelete" required class="color" matInput
                                                placeholder="Name" formControlName="EsName">

                                            <mat-error class="margin_tp"
                                                *ngIf="ExamSubForm.controls['EsName'].touched && ExamSubForm.controls['EsName'].errors?.required">
                                                {{'header.exam-subject.table.Mandatory'| translate}}
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-sm-2 mt-3">
                                        <mat-checkbox [disabled]="disableDelete" class="example-margin"
                                            formControlName="EsLang">
                                            Language ?
                                        </mat-checkbox>
                                    </div>
                                    <div class="col-sm-2 pr-0 mrgTop">
                                        <mat-form-field appearance="outline" class="example-full-width">
                                            <mat-label>
                                                Print
                                                Y/N/H
                                            </mat-label>
                                            <!-- <mat-select required class="colorblack" formControlName="EsPrint">
                                                            <mat-option value="Y">
                                                                Y
                                                            </mat-option>
                                                            <mat-option value="N">
                                                                N
                                                            </mat-option>
                                                            <mat-option value="H">
                                                                H
                                                            </mat-option>
                                                        </mat-select> -->
                                            <mat-select [disabled]="disableDelete" required #select559
                                                class="colorblack" formControlName="EsPrint">
                                                <mat-select-filter *ngIf="select559.focused" [placeholder]="'Filter'"
                                                    [displayMember]="'name'" [array]="printSelectDropDown"
                                                    (filteredReturn)="filterlistprintSelectDropDown =$event">
                                                </mat-select-filter>
                                                <mat-option *ngFor="let item of filterlistprintSelectDropDown"
                                                    [value]="item.name">
                                                    {{item.name}}
                                                </mat-option>
                                            </mat-select>
                                            <mat-error class="margin_tp"
                                                *ngIf="ExamSubForm.controls['EsPrint'].touched && ExamSubForm.controls['EsPrint'].errors?.required">
                                                {{'header.exam-subject.table.Mandatory'| translate}}
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-sm-3">
                                        <mat-form-field appearance="outline" class="example-full-width">
                                            <mat-label>Must Offer</mat-label>
                                            <mat-select [disabled]="disableDelete" multiple
                                                formControlName="EsCombCode">
                                                <mat-option (click)="selected(e,'must')" *ngFor="let e of mustOffer"
                                                    [value]="e.EsId">{{e.EsCode}} -
                                                    {{e.EsName}}</mat-option>
                                            </mat-select>
                                        </mat-form-field>

                                    </div>
                                    <div class="col-sm-3">
                                        <mat-form-field appearance="outline" class="example-full-width">
                                            <mat-label>Can't Offer</mat-label>
                                            <mat-select [disabled]="disableDelete" multiple formControlName="EsNoComb">
                                                <mat-option (click)="selected(e,'cant')" *ngFor="let e of cantOffer"
                                                    [value]="e.EsId">{{e.EsCode}} -
                                                    {{e.EsName}}</mat-option>
                                            </mat-select>
                                        </mat-form-field>


                                    </div>
                                    <div class="col-sm-2 mt-3" *ngIf="SubTotal==true">
                                        <mat-checkbox [disabled]="disableDelete" class="example-margin"
                                            formControlName="EsSubTot">
                                            SubTotal: {{value}}?
                                        </mat-checkbox>
                                    </div>
                                    <div class="col-sm-2" *ngIf="Semester==true">
                                        <mat-form-field appearance="outline" class="example-full-width">
                                            <mat-label>
                                                Semester
                                            </mat-label>
                                            <mat-select [disabled]="disableDelete" #select360 class="colorblack"
                                                formControlName="EsSeSr">
                                                <mat-select-filter *ngIf="select360.focused" [placeholder]="'Filter'"
                                                    [displayMember]="'SeName'" [array]="SemList"
                                                    (filteredReturn)="filteredListSem =$event">
                                                </mat-select-filter>
                                                <mat-option *ngFor="let item of filteredListSem" [value]="item.SeSr ">
                                                    {{item.SeName}}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-sm-3" *ngIf="CourseType==true">
                                        <mat-form-field appearance="outline" class="example-full-width">
                                            <mat-label>
                                                Course-Type
                                            </mat-label>
                                            <mat-select [disabled]="disableDelete" #select60 class="colorblack"
                                                formControlName="EsCoType">
                                                <mat-select-filter *ngIf="select60.focused" [placeholder]="'Filter'"
                                                    [displayMember]="'CdDesc'" [array]="CourseList"
                                                    (filteredReturn)="filteredListCourse =$event">
                                                </mat-select-filter>
                                                <mat-option *ngFor="let item of filteredListCourse"
                                                    [value]="item.CdCode">
                                                    {{item.CdDesc}}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    <!-- <div class="col-sm-3" *ngIf="PaperType==true">
                                        <mat-form-field appearance="outline" class="example-full-width">
                                            <mat-label>
                                                Paper-Type
                                            </mat-label>

                                            <mat-select [disabled]="disableDelete" #select60 class="colorblack"
                                                formControlName="EsThPr">
                                                <mat-select-filter *ngIf="select60.focused" [placeholder]="'Filter'"
                                                    [displayMember]="'CdCode'" [array]="ThPrList"
                                                    (filteredReturn)="filteredListThPr =$event">
                                                </mat-select-filter>
                                                <mat-option *ngFor="let item of filteredListThPr"
                                                    [value]="item.CdCode ">
                                                    {{item.CdDesc}}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div> -->
                                </div>

                            </div>

                        </div>
                        <div class="col-sm-12" *ngIf="OptionGridShow">
                            <p class="main-content-label f10">
                                Define Option
                                Codes
                            </p>
                            <div class="table-responsive table-container ">
                                <table class="table widthTb table-bordered text-nowrap text-center">
                                    <thead>
                                        <tr class="bgcolor">
                                            <th class="f600">Select
                                            </th>
                                            <th class="f600">OPT
                                            </th>
                                            <th class="f600">Min
                                            </th>
                                            <th class="f600">Max
                                            </th>
                                            <th class="f600"> Type </th>
                                            <th class="f600">Action
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody id="table_data" formArrayName="OptionGrid">
                                        <tr *ngFor="let option of getOptionGridControls();let last = last; let i = index"
                                            [formGroupName]="i">
                                            <td>
                                                <!-- <mat-radio-button class="ml-1 float"
                                                    [disabled]="(selectedoption == 'S' && option.get('OpSpFlag')?.value === 'G') || (Type == 'S' && option.get('OpSpFlag')?.value === 'G')"
                                                    [checked]="checkopcode(option.value.OpCode,option.value.Action)"
                                                    (click)="onItemChange(option)"
                                                    value="option.value.OpCode"></mat-radio-button> -->
                                                    <mat-checkbox class="ml-1 float"
                                                    [checked]="isChecked(option) || this.selectedRowIndex == i"
                                                    [disabled]="isDisabled(option)"
                                                    (change)="onCheckboxChange(option,i, $event.checked)"
                                                    value="option.value.OpCode">
                                      </mat-checkbox>  
                                            </td>
                                            <td>
                                                <input appUppercase [readonly]="disableDelete" class="form-control input-sm"
                                                    formControlName="OpCode" maxlength="1" (keyup)="onInputChange($event,i)">
                                                <mat-error class="margin_tp"
                                                    *ngIf="option.controls.OpCode.touched && option.controls.OpCode.errors?.pattern">
                                                    {{'header.exam-subject.table.Invalid'| translate}}
                                                </mat-error>
                                                <mat-error class="margin_tp"
                                                    *ngIf="option.controls.OpCode.touched && option.controls.OpCode.errors?.required">
                                                    {{'header.exam-subject.table.Mandatory'| translate}}
                                                </mat-error>
                                            </td>
                                            <td><input [readonly]="disableDelete" class="form-control input-sm"
                                                    formControlName="OpMin" maxlength="3">
                                                <mat-error class="margin_tp"
                                                    *ngIf="option.controls.OpMin.touched && option.controls.OpMin.errors?.pattern">
                                                    {{'header.exam-subject.table.Invalid'| translate}}
                                                </mat-error>
                                                <mat-error class="margin_tp"
                                                    *ngIf="option.controls.OpMin.touched && option.controls.OpMin.errors?.required">
                                                    {{'header.exam-subject.table.Mandatory'| translate}}
                                                </mat-error>
                                            </td>
                                            <td><input [readonly]="disableDelete" class="form-control input-sm"
                                                    formControlName="OpMax" maxlength="3">
                                                <mat-error class="margin_tp"
                                                    *ngIf="option.controls.OpMax.touched && option.controls.OpMax.errors?.pattern">
                                                    {{'header.exam-subject.table.Invalid'| translate}}
                                                </mat-error>
                                                <mat-error class="margin_tp"
                                                    *ngIf="option.controls.OpMax.touched && option.controls.OpMax.errors?.required">
                                                    {{'header.exam-subject.table.Mandatory'| translate}}
                                                </mat-error>
                                            </td>
                                            <td>
                                                <input readonly class="form-control input-sm"
                                                    formControlName="OpSpFlag" maxlength="1">
                                                <!-- {{option.OpSpFlag}} -->
                                            </td>
                                            <td>
                                                <a *ngIf="last" class="btn-floating" title="AddNew">
                                                    <i class="fa fa-plus" aria-hidden="true" (click)="addNewBtn()"></i>
                                                </a>
                                                <a  class="btn-floating" title="Remove">
                                                    <i class="fa fa-minus" title="Delete"
                                                        (click)="deleteOptionGrid(i,option,option.length)"></i></a>
                                            </td>
                                        </tr>

                                    </tbody>
                                </table>
                                <div class="col-sm-6">
                                    <mat-form-field appearance="outline" hidden class="example-full-width">
                                        <mat-label>
                                            Option
                                        </mat-label>
                                        <input readonly class="color" matInput placeholder="ShName"
                                            formControlName="ESubOption">

                                    </mat-form-field>
                                </div>



                            </div>

                            <!-- <button type="button"
                                                class="btn btn-primary my-2 me-2  btn-icon-text floatright btn btn-raised g-bg-blush2"
                                                (click)="nextTab()">
                                                    Next
                                            </button>
                                            <button type="button"
                                                class="mat-focus-indicator mat-menu-trigger btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                                (click)="close()">
                                              
                                                    Close
                                              
                                            </button> -->
                        </div>
                        <div class="row col-md-12">
                            <div class="col-sm-12 prpl">
                                <button id="Next" type="button" class="btn btn-primary btn-icon-text floatright mt-1"
                                    (click)="nextTab()">
                                    <span style="display: contents; align-items: center;">
                                        <img width="20vh" src="../../assets/img/turn-right.gif"
                                            style="margin-right: 5px;">
                                        {{'header.exam-subject.table.Next'| translate}}
                                    </span>
                                </button>
                                <button id="Close" type="button" class="btn btn-primary btn-icon-text floatright mr-3 mt-1"
                                    (click)="close()">
                                    <span style="display: contents; align-items: center;">
                                        <img width="20vh" src="../../assets/img/letter-x.gif"
                                            style="margin-right: 7px;">
                                        {{'header.exam-subject.table.Close'| translate}}
                                    </span>
                                </button>
                            </div>
                        </div>

                    </div>
                </div>
            </mat-tab>
            <mat-tab [disabled]="nextTabDisabled" label="{{Title}} Marks Details">
                <div class="card-body mt-3">
                    <div class="row clearfix">
                        <div class="col-sm-6 margindotted">
                            <h6 class="main-content-label f10">
                                selected
                                option ({{Title}})
                            </h6>
                            <div class="row">
                                <div class="col-sm-4" *ngIf="ValType">
                                    <mat-form-field appearance="outline" class="example-full-width">
                                        <mat-label>
                                            Value Type
                                        </mat-label>
                                        <mat-select [disabled]="disableDelete" #select59 class="colorblack"
                                            formControlName="EsMarkGrd">
                                            <mat-select-filter *ngIf="select59.focused" [placeholder]="'Filter'"
                                                [displayMember]="'CdCode'" [array]="ValTypeList"
                                                (filteredReturn)="filteredListVal =$event">
                                            </mat-select-filter>
                                            <mat-option (click)="showGrade()" *ngFor="let item of filteredListVal"
                                                [value]="item.CdCode ">
                                                {{item.CdDesc}}
                                            </mat-option>
                                        </mat-select>

                                        <mat-error class="margin_tp"
                                            *ngIf="ExamSubForm.controls['EsMarkGrd'].touched && ExamSubForm.controls['EsMarkGrd'].errors?.required">
                                            {{'header.exam-subject.table.Mandatory'| translate}}
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="col-sm-4" *ngIf="UniColg">
                                    <mat-form-field appearance="outline" class="example-full-width">
                                        <mat-label>
                                            University / College
                                        </mat-label>
                                        <mat-select [disabled]="disableDelete" class="colorblack"
                                            formControlName="EsCollUni">
                                            <mat-option value="U">
                                                University
                                            </mat-option>
                                            <mat-option value="C">
                                                College
                                            </mat-option>
                                        </mat-select>
                                        <mat-error class="margin_tp"
                                            *ngIf="ExamSubForm.controls['EsCollUni'].touched && ExamSubForm.controls['EsCollUni'].errors?.pattern">
                                            {{'header.exam-subject.table.Invalid'| translate}}
                                        </mat-error>
                                        <mat-error class="margin_tp"
                                            *ngIf="ExamSubForm.controls['EsCollUni'].touched && ExamSubForm.controls['EsCollUni'].errors?.required">
                                            {{'header.exam-subject.table.Mandatory'| translate}}
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="col-sm-10">
                                    <div class="row">
                                        <div class="col-sm-5" *ngIf="CarryOver">
                                            <mat-checkbox [disabled]="disableDelete" class="example-margin"
                                                formControlName="EsACF">
                                                Carry Over
                                            </mat-checkbox>
                                        </div>
                                        <div class="col-sm-5" *ngIf="ExclTotal">
                                            <mat-checkbox [disabled]="disableDelete" class="example-margin"
                                                formControlName="EsExclTot">
                                                Exclude From Total
                                            </mat-checkbox>
                                        </div>
                                        <div class="col-sm-5" *ngIf="ScaleDown">
                                            <mat-checkbox [disabled]="disableDelete" class="example-margin"
                                                formControlName="EsSpFlag">
                                                Scale
                                                Down/UP
                                            </mat-checkbox>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-10" *ngIf="Text">
                                    <p>Convert to Grade Y</p>
                                </div>
                                <div class="col-sm-12">
                                    <div class="row">
                                        <div class="col-sm-3 mt-2" *ngIf="MaxMarks">
                                            <mat-form-field appearance="outline" class="example-full-width">
                                                <mat-label>
                                                    Max Marks
                                                </mat-label>
                                                <input [readonly]="disableDelete" [required]="selectedoption === 'S' || data.value.EsType === 'S'" class="color" matInput maxlength="4"
                                                    placeholder="Max Marks" formControlName="EsMaxMarks">
                                                    <mat-error class="margin_tp"
                                                    *ngIf="ExamSubForm.controls['EsMaxMarks'].touched && ExamSubForm.controls['EsMaxMarks'].errors?.pattern">
                                                        In-Valid
                                                    </mat-error>
                                                    <mat-error  class="margin_tp"
                                                    *ngIf="ExamSubForm.controls['EsMaxMarks'].touched && ExamSubForm.controls['EsMaxMarks'].errors?.required">
                                                        Required
                                                    </mat-error>
                                            </mat-form-field>
                                        </div>
                                        
                                        <div class="col-sm-2 mt-2" *ngIf="Sec">
                                            <mat-form-field appearance="outline" class="example-full-width">
                                                <mat-label>
                                                    Section
                                                </mat-label>
                                                <input [readonly]="disableDelete"  (keyup)="marksInput()" class="color"
                                                    maxlength="3" matInput placeholder="Sec"
                                                    formControlName="EsPartMarks">
                                                <mat-error class="margin_tp"
                                                    *ngIf="ExamSubForm.controls['EsPartMarks'].touched && ExamSubForm.controls['EsPartMarks'].errors?.pattern">
                                                    In-Valid
                                                </mat-error>
                                                <!-- <mat-error class="margin_tp"
                                                                *ngIf="ExamSubForm.controls['EsPartMarks'].touched && ExamSubForm.controls['EsPartMarks'].errors?.required">
                                                                Required
                                                            </mat-error> -->
                                            </mat-form-field>
                                        </div>
                                        <div class="col-sm-7" *ngIf="Marks" formArrayName="marksGrid">
                                            Section Marks
                                            <div class="row">
                                                <div class="col-sm-2"
                                                    *ngFor="let option of  getmarksGridControls(); let i = index"
                                                    [formGroupName]="i">
                                                    <input [readonly]="disableDelete" required class="color marks flex"
                                                        maxlength="4" formControlName="EsQMarksValue" autocomplete="off"
                                                        maxlength="3" style="width: 40px; height: 33px;">
                                                    <mat-error class="margin_tp"
                                                        *ngIf="option.controls.EsQMarksValue.touched && option.controls.EsQMarksValue.errors?.pattern">
                                                        {{'header.exam-subject.table.Invalid'| translate}}
                                                    </mat-error>
                                                </div>

                                            </div>

                                        </div>
                                    </div>

                                </div>
                                <!-- <div class="col-sm-12">
                                                <div class="row">
                                                    <mat-radio-group  onkeydown="return (event.keyCode!=13);"
                                                     formControlName="CDMARKPERCENTAGE" class="example-full-width"  (change)="showMarkPercentage()">
                                                    <div class="row">
                                                    <div class="col-sm-5">
                                                     <mat-radio-button  value=true>Enter by Marks</mat-radio-button>
                                                     </div>
                                                      <div class="col-sm-5">
                                                        <mat-radio-button value=false>Enter by Percentage</mat-radio-button>
                                                        </div>
                                                    </div>
                                                    </mat-radio-group>
                                                </div>
                                            </div> -->
                                            <div class="col-sm-12">
                                                <div class="row">
                                                    <!-- *ngIf="PassMarks && showMarkPerc " -->
                                                    <div class="col-sm-3" >
                                                        <mat-form-field appearance="outline"  class="example-full-width" >
                                                            <mat-label>
                                                                Pass Marks
                                                            </mat-label>
                                                            <input [readonly]="disableDelete" (change)="passmarks()" maxlength="4" class="color"  maxlength="3" matInput placeholder="Pass Marks"
                                                                formControlName="EsPassMarks">
                                                                <mat-error class="margin_tp"
                                                                *ngIf="ExamSubForm.controls['EsPassMarks'].touched && ExamSubForm.controls['EsPassMarks'].errors?.pattern">
                                                               In-Valid
                                                            </mat-error>
                                                            <!-- <mat-error class="margin_tp"
                                                                *ngIf="ExamSubForm.controls['EsPassMarks'].touched && ExamSubForm.controls['EsPassMarks'].errors?.required">
                                                                Required
                                                            </mat-error> -->
                                            </mat-form-field>

                                        </div>
                                        <div class="col-sm-2" *ngIf="PassPercent">
                                            <mat-form-field appearance="outline" class="example-full-width">
                                                <mat-label>
                                                    %
                                                </mat-label>
                                                <input [readonly]="disableDelete" class="color" matInput placeholder="%"
                                                    formControlName="EsPassPC" step="0.01" maxlength="5">
                                                <mat-error class="margin_tp"
                                                    *ngIf="ExamSubForm.controls['EsPassPC'].touched && ExamSubForm.controls['EsPassPC'].errors?.pattern">
                                                    In-Valid
                                                </mat-error>
                                                <!-- <mat-error class="margin_tp"
                                                                *ngIf="ExamSubForm.controls['EsPassPC'].touched && ExamSubForm.controls['EsPassPC'].errors?.required">
                                                                Required
                                                            </mat-error> -->
                                            </mat-form-field>
                                        </div>
                                    </div>

                                </div>
                                <div class="col-sm-12">
                                    <div class="row">
                                        <div class="col-sm-3">
                                            <!-- *ngIf="ExamMarks" -->
                                            <mat-form-field appearance="outline" class="example-full-width">
                                                <mat-label>
                                                    Exempted Marks
                                                </mat-label>
                                                <input [readonly]="disableDelete" matTooltip="Exempted Marks"
                                                    maxlength="4" (change)="passmarks()" class="color" maxlength="3"
                                                    matInput placeholder="Exempted Marks" formControlName="EsExmMarks">
                                                <mat-error class="margin_tp"
                                                    *ngIf="ExamSubForm.controls['EsExmMarks'].touched && ExamSubForm.controls['EsExmMarks'].errors?.pattern">
                                                    In-Valid
                                                </mat-error>
                                                <!-- <mat-error class="margin_tp"
                                                                *ngIf="ExamSubForm.controls['EsExmMarks'].touched && ExamSubForm.controls['EsExmMarks'].errors?.required">
                                                                Required
                                                            </mat-error> -->
                                            </mat-form-field>

                                        </div>
                                        <div class="col-sm-2">
                                            <!-- *ngIf="ExamPercent" -->
                                            <mat-form-field appearance="outline" class="example-full-width">
                                                <mat-label>
                                                    %
                                                </mat-label>
                                                <input [readonly]="disableDelete" class="color" matInput placeholder="%"
                                                    formControlName="EsExmPC" step="0.01" maxlength="5">
                                                <mat-error class="margin_tp"
                                                    *ngIf="ExamSubForm.controls['EsExmPC'].touched && ExamSubForm.controls['EsExmPC'].errors?.pattern">
                                                    In-Valid
                                                </mat-error>
                                                <!-- <mat-error class="margin_tp"
                                                                *ngIf="ExamSubForm.controls['EsExmPC'].touched && ExamSubForm.controls['EsExmPC'].errors?.required">
                                                                Required
                                                            </mat-error> -->
                                            </mat-form-field>

                                        </div>
                                        <!-- 26-02-2024 -->
                                        <!-- <div class="col-sm-6">
                                            <mat-checkbox [disabled]="disableDelete" class="example-margin"
                                                formControlName="EsMustPass">
                                                Must
                                                Pass
                                            </mat-checkbox>
                                        </div> -->
                                    </div>
                                </div>
                                <div class="col-sm-12">
                                    <div class="row">
                                        <div class="col-sm-3">
                                            <mat-form-field appearance="outline" class="example-full-width">
                                                <mat-label>
                                                    Distinction
                                                    Mark
                                                </mat-label>
                                                <input [readonly]="disableDelete" matTooltip="Distinction Marks"
                                                    maxlength="4" (change)="passmarks()" class="color" maxlength="3"
                                                    matInput placeholder="Dist Marks" formControlName="EsDistMarks">
                                                <mat-error class="margin_tp"
                                                    *ngIf="ExamSubForm.controls['EsDistMarks'].touched && ExamSubForm.controls['EsDistMarks'].errors?.pattern">
                                                    In-Valid
                                                </mat-error>
                                                <!-- <mat-error class="margin_tp"
                                                                *ngIf="ExamSubForm.controls['EsDistMarks'].touched && ExamSubForm.controls['EsDistMarks'].errors?.required">
                                                                Required
                                                            </mat-error> -->
                                            </mat-form-field>

                                        </div>
                                        <div class="col-sm-2" *ngIf="DistPercent">
                                            <mat-form-field appearance="outline" class="example-full-width">
                                                <mat-label>
                                                    %
                                                </mat-label>
                                                <input [readonly]="disableDelete" class="color" matInput placeholder="%"
                                                    formControlName="EsDistPC" step="0.01" maxlength="5">

                                                <mat-error class="margin_tp"
                                                    *ngIf="ExamSubForm.controls['EsDistPC'].touched && ExamSubForm.controls['EsDistPC'].errors?.pattern">
                                                    In-Valid
                                                </mat-error>
                                                <!-- <mat-error class="margin_tp"
                                                                *ngIf="ExamSubForm.controls['EsDistPC'].touched && ExamSubForm.controls['EsDistPC'].errors?.required">
                                                                Required
                                                            </mat-error> -->
                                            </mat-form-field>
                                        </div>
                                        <div class="col-sm-5" *ngIf="DistSign">
                                            <mat-form-field appearance="outline" class="example-full-width">
                                                <mat-label>
                                                    Dist
                                                    Sign
                                                </mat-label>
                                                <input [readonly]="disableDelete" class="color" maxlength="1" matInput
                                                    placeholder="Dist Sign" formControlName="EsDistRem">
                                                <mat-error class="margin_tp"
                                                    *ngIf="ExamSubForm.controls['EsDistRem'].touched && ExamSubForm.controls['EsDistRem'].errors?.pattern">
                                                    {{'header.exam-subject.table.Invalid'| translate}}
                                                </mat-error>
                                                <!-- <mat-error class="margin_tp"
                                                                *ngIf="ExamSubForm.controls['EsDistRem'].touched && ExamSubForm.controls['EsDistRem'].errors?.required">
                                                                Mandatory
                                                            </mat-error> -->
                                            </mat-form-field>

                                        </div>
                                        <div class="col-sm-6" *ngIf="Credits">
                                            <mat-form-field appearance="outline" class="example-full-width">
                                                <mat-label>
                                                    Credits
                                                </mat-label>
                                                <input [readonly]="disableDelete" class="color" matInput
                                                    placeholder="Credits" formControlName="EsCredit" maxlength="5">

                                            </mat-form-field>
                                        </div>

                                    </div>

                                </div>
                                <!-- Dont remove the code  -->

                                <!-- Dont remove the code above -->

                                <div class="col-sm-4 mt-4" *ngIf="DefBtn">
                                    <mat-checkbox [readonly]="disableDelete" (change)="markasDefault($event.checked)"
                                        class="example-margin" formControlName="EsDeAct">Mark As Default Grade</mat-checkbox>
                                </div>
                                <div class="col-sm-6" *ngIf="GrdBtn">
                                    <!-- <button type="button" (click)="openSubjectGradePointsPopUP()"
                                                    class="btn btn-primary my-2 me-2  btn-icon-text btn btn-raised g-bg-blush2">

                                                        Grade Points
                                                   
                                                </button> -->

                                    <button id="GradePoints" type="button" class="btn btn-primary btn-icon-text floatright mr-3 mt-3"
                                        (click)="openSubjectGradePointsPopUP()">
                                        <span style="display: contents; align-items: center;">
                                            <!-- <img width="20vh" src="../../assets/img/turn-left.gif"
                                                            style="margin-right: 7px;"> -->
                                            Grade Points
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div class="col-sm-6">
                            <p class="main-content-label f10">
                                Define Grades
                                From Top
                            </p> 
                            <div class="table-responsive table-container ">
                                <table  class="table widthTb table-bordered text-nowrap text-center">
                                    <thead>
                                        <tr class="bgcolor">
                                            <th width="20%" class="f600">{{'header.exam-subject.table.ExamGrade'| translate}}
                                            </th>
                                            <th width="20%" class="f600">{{'header.exam-subject.table.ExamPass'| translate}}
                                            </th>
                                            <th width="20%" class="f600">{{'header.exam-subject.table.Exam'| translate}}
                                            </th>
                                            <th width="20%" class="f600">{{'header.exam-subject.table.ExamMarks'| translate}}
                                            </th>
                                            <th width="20%" class="f600">{{'header.exam-subject.table.Action'| translate}}
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody id="table_data" formArrayName="DefineGrid">
                                        <tr *ngFor="let option of getDefineGridControls();let last =last; let i = index"
                                            [formGroupName]="i">
                                            <td>
                                                <input [readonly]="disableDelete" maxlength="3"
                                                    class="form-control input-sm" formControlName="EsGrd">
                                            </td>
                                            <td>
                                                <mat-select [disabled]="disableDelete" formControlName="EsPass">
                                                    <mat-option (click)="PassValue('P',i)" value="P">
                                                        Pass
                                                    </mat-option>
                                                    <mat-option (click)="PassValue('F',i)" value="F">
                                                        Fail
                                                    </mat-option>
                                                </mat-select>
                                            </td>
                                            <td>
                                                <mat-select [disabled]="disableDelete" formControlName="EsExm">
                                                    <mat-option (click)="ExamValue('Y',i)" value="Y">
                                                        Yes
                                                    </mat-option>
                                                    <mat-option (click)="ExamValue('N',i)" value="N">
                                                        No
                                                    </mat-option>
                                                    <mat-option value="E" disabled>
                                                        E
                                                    </mat-option>
                                                </mat-select>
                                            </td>
                                            <td>

                                                <input [readonly]="disableDelete" maxlength="3"
                                                    class="form-control input-sm" formControlName="EsMrk">

                                            </td>
                                            <td>
                                                <a *ngIf="last" class="floating" title="AddNew">
                                                    <i class="fa fa-plus" aria-hidden="true"
                                                        (click)="addDefineGrdBtn()"></i>

                                                </a>
                                                <a *ngIf="last" class="floating" title="Remove">
                                                    <i class="fa fa-minus" title="Delete"
                                                        (click)="deleteRow(i)"></i></a>
                                            </td>
                                        </tr>
                                    </tbody>
                                 </table>
                            </div>
                           

                            <!-- <button type="button"
                                            class="mat-focus-indicator mat-menu-trigger btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                            (click)="close()">
                                                Close
                                        </button>
                                        <button type="button" *ngIf="Submitbtn"
                                            class="btn btn-primary my-2 me-2  btn-icon-text floatright btn btn-raised g-bg-blush2"
                                            (click)="submit()">
                                                Write
                                        </button>
                                        <button type="button" *ngIf="Updatebtn"
                                            class="btn btn-primary my-2 me-2  btn-icon-text floatright btn btn-raised g-bg-blush2"
                                            (click)="update()">
                                                Update
                                        </button>
                                        <button type="button" *ngIf="Deletebtn"
                                            class="btn btn-primary my-2 me-2  btn-icon-text floatright btn btn-raised g-bg-blush2"
                                            (click)="delete()">
                                                Delete
                                        </button>
                                        <button type="button"
                                            class="mat-focus-indicator mat-menu-trigger btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                            (click)="prevTab()">
                                                Back
                                        </button> -->
                        </div>
                        <div class="row col-md-12 ">
                            <div class="col-sm-12 prpl ml">
                                <button id="Close1" type="button" class="btn btn-primary btn-icon-text floatright mt-1"
                                    (click)="close()">
                                    <span style="display: contents; align-items: center;">
                                        <img width="20vh" src="../../assets/img/letter-x.gif"
                                            style="margin-right: 5px;">
                                        {{'header.exam-subject.table.Close'| translate}}
                                    </span>
                                </button>
                                <button id="Delete" *ngIf="Deletebtn && subjectDelete" type="button"
                                    class="btn btn-primary btn-icon-text floatright mr-3 mt-1" (click)="delete()">
                                    <span style="display: contents; align-items: center;">
                                        <img width="20vh" src="../../assets/img/trash.gif"
                                            style="margin-right: 7px;">
                                        {{'header.exam-subject.table.Delete'| translate}}
                                    </span>
                                </button>
                                <button id="Update" *ngIf="Updatebtn && subjectUpdate" type="button"
                                    class="btn btn-primary btn-icon-text floatright mr-3 mt-1" (click)="update()">
                                    <span style="display: contents; align-items: center;">
                                        <img width="20vh" src="../../assets/img/edit1.gif"
                                            style="margin-right: 7px;">
                                        {{'header.exam-subject.table.Update'| translate}}
                                    </span>
                                </button>
                                <button id="Save" *ngIf="Submitbtn && subjectCreate" type="button"
                                    class="btn btn-primary btn-icon-text floatright mr-3 mt-1" (click)="submit()">
                                    <span style="display: contents; align-items: center;">
                                        <img width="20vh" src="../../assets/img/save.gif"
                                            style="margin-right: 7px;">
                                        {{'header.exam-subject.table.Save'| translate}}
                                    </span>
                                </button>
                                <button id="Back" type="button" class="btn btn-primary btn-icon-text floatright mr-3 mt-1"
                                    (click)="prevTab()">
                                    <span style="display: contents; align-items: center;">
                                        <img width="20vh" src="../../assets/img/turn-left.gif"
                                            style="margin-right: 7px;">
                                        {{'header.exam-subject.table.Back'| translate}}
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-tab>
            <div class="col-sm-12 align-right">

                <button type="button"
                    class="mat-focus-indicator mat-menu-trigger btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base">

                    {{'header.exam-subject.titleList.Back'
                    |
                    translate
                    }}

                </button>
                <button type="button" id="Next1"
                    class="btn btn-primary my-2 me-2  btn-icon-text floatright btn btn-raised g-bg-blush2"
                    (click)="next()">
                    Next

                </button>
            </div>
        </mat-tab-group>


    </div>
</form>